import { render, staticRenderFns } from "./video-archive-item.vue?vue&type=template&id=98edb290"
import script from "./video-archive-item.vue?vue&type=script&lang=js"
export * from "./video-archive-item.vue?vue&type=script&lang=js"
import style0 from "./video-archive-item.vue?vue&type=style&index=0&id=98edb290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports